import { render, staticRenderFns } from "./GenericTask.vue?vue&type=template&id=2661dc1e"
import script from "./GenericTask.vue?vue&type=script&lang=js"
export * from "./GenericTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports